import { Button } from '../Components';

const Welcome = ({ setScreen }) => {
    return (
        <div className="bg-welcome h-full bg-cover bg-center relative">
            <div className="w-full flex justify-center bottom-8 lg:bottom-20 xl:bottom-40 absolute">
                <Button onClick={() => setScreen('how-to-play')}>
                    PLAY NOW
                </Button>
            </div>
        </div>
    );
};

export default Welcome;
